/** Resource Usage rows, kept out of `tenant-billing-page.tsx` so they can be tested in isolation. */

/**
 * Render a single "N / limit" row for the Resource Usage grid. `null` /
 * `undefined` limit renders as `"unlimited"`; when the used count reaches
 * the capped limit the row turns destructive-colored.
 */
export function renderUsage(
  label: string,
  current: number | undefined,
  limit: number | null | undefined,
) {
  const used = current ?? 0
  const limitStr = limit === null || limit === undefined ? 'unlimited' : String(limit)
  const isAtLimit = limit !== null && limit !== undefined && used >= limit
  return (
    <div>
      <div className="text-xs text-muted-foreground">{label}</div>
      <div className={`text-sm font-mono ${isAtLimit ? 'text-destructive' : ''}`}>
        {used} <span>/</span> {limitStr}
      </div>
    </div>
  )
}

export function renderUnavailableUsage(label: string) {
  return (
    <div>
      <div className="text-xs text-muted-foreground">{label}</div>
      <div className="text-sm font-mono text-muted-foreground">unavailable</div>
    </div>
  )
}
